import {useEffect, useState} from 'react'
import {Modal, message} from 'antd'
import {Box, Text, Flex, Button, Image, Input, useToast} from '@chakra-ui/react'
import Book from '@assets/svgs/learn/book.svg'
import Check from '@assets/svgs/learn/check.svg'
import Plus from '@assets/svgs/learn/plus.svg'
import {useDispatch, useSelector} from 'react-redux'
import notebookRequest from '@apis/notebook'
import Loading from '@components/Loading'
import {
  updateIsShowSavePhraseForm,
  updatePhraseToSave,
} from '@redux/shared/shared'
import CheckCircle from '@assets/svgs/learn/check_circle.svg'

const SavePhraseForm = ({handleAfterSuccess}: {handleAfterSuccess: any}) => {
  const {isShowSavePhraseForm, phraseToSave} = useSelector(
    (state: any) => state.shared,
  )
  const [folders, setFolders] = useState<any>()
  const [currentFolderSelected, setCurrentFolderSelected] = useState<any>()
  const [inputNameFolder, setInputNameFolder] = useState<any>()
  const [isLoading, setIsLoading] = useState<any>()
  const [isOpenCreateFolderForm, setIsOpenCreateFolderForm] =
    useState<any>(false)
  const [messageApi, contextHolder] = message.useMessage()
  const [recentlySaveFolder, setRecentlySaveFolder] = useState<any>()
  const toast = useToast()

  const dispatch = useDispatch()

  useEffect(() => {
    getFolders()
  }, [])

  useEffect(() => {
    getFirstFolder()
  }, [folders, isShowSavePhraseForm])

  useEffect(() => {
    if (!phraseToSave) return
    const params = {
      sentence: phraseToSave,
      phrase: phraseToSave,
      index: 0,
    }
    checkRecentlySavedFolder(params)
  }, [phraseToSave, isShowSavePhraseForm])

  const getFolders = async () => {
    setIsLoading(true)
    try {
      const params = {
        'lesson-id': 'lesson_1',
      }
      const res = await notebookRequest.getFolderSavePhrase(params)
      const folders = [...res?.data?.data?.folders]
      setFolders(folders)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  const handleCreateFolder = async () => {
    setIsLoading(true)
    try {
      const upDateInputNameFolder = inputNameFolder.replace(/^\s+|\s+$/g, '')
      const params = {name: upDateInputNameFolder}
      const res = await notebookRequest.createFolder(params)
      if (res?.status === 200) {
        setInputNameFolder('')
        setFolders((pre: any) => [res.data.data, ...pre])
        messageApi.success('Thành công!')
      }
    } catch (error) {
      messageApi.error('Thất bại!')
    }
    setIsLoading(false)
    setIsOpenCreateFolderForm(false)
  }

  const handleSaveInFolder = async () => {
    setIsLoading(true)
    try {
      const params = {
        sentence: phraseToSave,
        phrase: phraseToSave,
        index: 0,
        folder_name: currentFolderSelected.name,
      }
      await notebookRequest.savePhrase(params)
      handleCancelSavePhraseForm()
      handleAfterSuccess()
      const idToast = toast({
        isClosable: true,
        position: 'bottom-left',
        duration: 7000,
        render: () => (
          <Box
            onClick={() => toast.close(idToast)}
            p={'24px'}
            bg="white"
            borderRadius={'16px'}
            boxShadow={
              '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)'
            }>
            <Flex gap={'16px'} fontSize={'16px'} fontWeight={600}>
              <Image src={CheckCircle} />
              <Text>
                Lưu thành công cụm từ vào sổ tay{' '}
                {currentFolderSelected?.name || ''}
              </Text>
            </Flex>
          </Box>
        ),
      })
    } catch (error) {
      console.log({error})
      messageApi.error('Thất bại!')
    }
    setIsLoading(false)
  }

  const checkRecentlySavedFolder = async (params: any) => {
    const res = await notebookRequest.checkRecentlySavedFolder(params)
    if (res?.status === 200) {
      setRecentlySaveFolder(res.data.data)
    } else {
      setRecentlySaveFolder(null)
    }
  }

  const getFirstFolder = () => {
    if (folders?.length > 0) {
      const firstFolder = folders[0]
      setCurrentFolderSelected(firstFolder)
    }
  }

  const handleCancelSavePhraseForm = () => {
    dispatch(updateIsShowSavePhraseForm(false))
    dispatch(updatePhraseToSave(null))
    setCurrentFolderSelected(null)
    setRecentlySaveFolder(null)
  }

  const handleCancelCreateFolderForm = () => {
    setIsOpenCreateFolderForm(false)
  }

  const handleSelectorFolder = (item: any) => {
    setCurrentFolderSelected(item)
  }

  const handleClickCreateFolder = () => {
    setIsOpenCreateFolderForm(true)
  }

  const handleChangeInputNameFolder = (e: any) => {
    if (e.target.value.length > 50) {
      return
    }
    let nameFolder = e.target.value.replace(/^\s+/, '')
    setInputNameFolder(nameFolder)
  }

  const handleKeyDownInputNameFolder = (e: any) => {
    if ((e.code === 'Enter' || e.key === 'Enter') && inputNameFolder) {
      handleCreateFolder()
    }
  }

  return (
    <>
      {contextHolder}

      <Modal
        title={
          <Text fontSize={'20px'} fontWeight={600}>
            Chọn mục để lưu
          </Text>
        }
        destroyOnClose={true}
        zIndex={1000}
        open={isShowSavePhraseForm}
        width={400}
        footer={null}
        styles={{
          content: {borderRadius: '24px', padding: '28px'},
        }}
        onCancel={handleCancelSavePhraseForm}>
        {recentlySaveFolder && (
          <Text
            color={
              '#0050B3'
            }>{`Suỵt! Bạn đã lưu cụm này vào ${recentlySaveFolder?.folder_name} rồi`}</Text>
        )}
        <Box
          className="scroll-bar"
          //   ref={scrollRef}
          mt={'16px'}
          borderRadius={'8px'}
          border={'1px solid #EAECF0'}
          h={'270px'}
          overflow={'auto'}
          overflowX={'hidden'}
          position={'relative'}>
          {isLoading && <Loading />}

          {folders?.map((item: any, index: any) => {
            return (
              <Flex
                key={index}
                gap={'12px'}
                alignItems={'center'}
                p={'8px 16px'}
                borderBottom={'1px solid #EAECF0'}
                cursor={'pointer'}
                onClick={() => handleSelectorFolder(item)}>
                <Flex
                  w={'44px'}
                  h={'44px'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  borderRadius={'4px'}
                  bg={'#EFF8FF'}
                  flexShrink={0}>
                  <Image src={Book} />
                </Flex>
                <Flex flex={1} justifyContent={'space-between'}>
                  <Text className="line-clamp-1" fontSize={'16px'}>
                    {item.name}
                  </Text>
                  {currentFolderSelected?.id === item.id && (
                    <Image src={Check} />
                  )}
                </Flex>
              </Flex>
            )
          })}
        </Box>
        <Flex justifyContent={'space-between'} mt={'16px'}>
          <Flex
            pointerEvents={isLoading ? 'none' : 'unset'}
            opacity={isLoading ? 0.5 : 1}
            gap={'8px'}
            alignItems={'center'}
            cursor={'pointer'}
            onClick={handleClickCreateFolder}>
            <Image src={Plus} />
            <Text fontSize={'16px'} fontWeight={700} color={'#2E90FA'}>
              Tạo mới
            </Text>
          </Flex>
          <Button
            isDisabled={isLoading}
            fontSize={'16px'}
            fontWeight={700}
            color={'white'}
            borderRadius={'12px'}
            bg={'#1890FF'}
            cursor={'pointer'}
            _hover={{
              bg: '#49a7ff',
            }}
            onClick={handleSaveInFolder}>
            {!isLoading ? 'Lưu' : 'Đang lưu'}
          </Button>
        </Flex>
      </Modal>

      {/* Create folder form */}
      <Modal
        title={
          <Text fontSize={'16px'} fontWeight={600}>
            Tạo thư mục mới
          </Text>
        }
        destroyOnClose={true}
        zIndex={1501}
        open={isOpenCreateFolderForm}
        footer={null}
        styles={{
          content: {borderRadius: '24px', padding: '28px'},
        }}
        onCancel={handleCancelCreateFolderForm}>
        <Flex gap={'16px'} alignItems={'center'} mt={'16px'}>
          <Input
            placeholder="Nhập tên mục"
            value={inputNameFolder}
            onChange={handleChangeInputNameFolder}
            onKeyDown={handleKeyDownInputNameFolder}></Input>
          <Button
            isDisabled={Boolean(!inputNameFolder) || isLoading}
            fontSize={'16px'}
            fontWeight={700}
            color={'white'}
            borderRadius={'12px'}
            bg={'#1890FF'}
            _hover={{
              bg: '#49a7ff',
            }}
            onClick={handleCreateFolder}>
            {!isLoading ? 'Tạo' : 'Đang tạo'}
          </Button>
        </Flex>
      </Modal>
    </>
  )
}

export default SavePhraseForm
